export const CLAM_2026_27_LAUNCH = {
  "id": "clam-2026-27",
  "slug": "clam-new-gear-2026-27",
  "sectionBasePath": "/ice-fishing",
  "brand": "Clam Outdoors",
  "launchSeason": "2026-27",
  "pageTitle": "Clam’s New Ice Fishing Gear for 2026–27: The Full Behind-the-Scenes Look",
  "seoTitle": "Clam 2026-27 Ice Fishing Gear: Full New-Gear Guide",
  "metaDescription": "Explore Clam’s 2026-27 Pack Trap, flip-over and hub shelters, ClamAYR, IceArmor apparel, TS rods and tungsten tackle with Alex Timm’s first-look notes and buying links.",
  "authorName": "Alex Timm",
  "publishedDate": "2026-10-23",
  "breadcrumbs": [
    {
      "label": "Home",
      "path": "/"
    },
    {
      "label": "Ice Fishing",
      "path": "/ice-fishing"
    },
    {
      "label": "Clam 2026-27 Gear"
    }
  ],
  "intro": [
    "I went behind the scenes at Clam HQ to see the new gear, talk with the people behind it and compare the details that matter. Start with the product list, then use the comparisons to narrow your choices.",
    "This is a hands-on first look, with manufacturer specifications and my observations from the walkthrough."
  ],
  "independenceDisclosure": "I buy all my fishing gear. No free stuff. No paid reviews. No money from fishing brands.",
  "affiliateDisclosure": "Some links are affiliate links. Purchases may earn me a commission from retailers at no extra cost to you and help fund independent gear coverage.",
  "videoId": null,
  "videoTitle": "Clam’s New Ice Fishing Gear for 2026–27: The Full Behind-the-Scenes Look",
  "visual": {
    "brandAccent": "#0F50F2",
    "heroTitle": "Clam’s 2026-27 ice gear, explained.",
    "guideLabel": "INDEPENDENT GUIDE TO",
    "seasonLabel": "2026-27 ICE FISHING",
    "updatedLabel": "Prices checked October 23, 2026",
    "productCountLabel": "Shelters, apparel, rods and tackle",
    "logo": {
      "src": "/images/launches/clam-2026-27/clam-logo.webp",
      "alt": "Clam Outdoors",
      "width": 400,
      "height": 400
    },
    "heroImage": {
      "src": "/images/launches/clam-2026-27/clam-pack-sled-in-use.webp",
      "alt": "Clam Pack Sled ski platform in use",
      "width": 1400,
      "height": 1400,
      "fit": "cover"
    }
  },
  "jumpNav": [
    {
      "href": "#whats-new",
      "label": "Gear and Buying Links"
    },
    {
      "href": "#pack-system",
      "label": "Pack System"
    },
    {
      "href": "#flip-overs",
      "label": "Flip-over Shelters"
    },
    {
      "href": "#hubs",
      "label": "X-Series Hubs"
    },
    {
      "href": "#clamayr",
      "label": "ClamAYR"
    },
    {
      "href": "#apparel",
      "label": "IceArmor Apparel and Boots"
    },
    {
      "href": "#rods",
      "label": "Rods and Reels"
    },
    {
      "href": "#tackle",
      "label": "Tungsten Spoons and Jigs"
    }
  ],
  "launchIndex": {
    "eyebrow": "THE GEAR FROM THE WALKTHROUGH",
    "heading": "What’s new from Clam for 2026-27?",
    "intro": "Explore the new and revised gear from the walkthrough, with the useful differences and a buying link beside every product. Prices shown are Clam’s listed prices checked October 23, 2026; retailer prices and availability may differ.",
    "groups": [
      {
        "id": "pack-system",
        "label": "Pack System",
        "productIds": [
          "pack-sled",
          "pack-trap-1",
          "pack-trap-2"
        ]
      },
      {
        "id": "flip-overs",
        "label": "Flip-over Shelters",
        "productIds": [
          "kenai",
          "nanook",
          "yukon",
          "denali",
          "denali-x4"
        ]
      },
      {
        "id": "hubs",
        "label": "X-Series Hubs",
        "productIds": [
          "x-400",
          "x-600",
          "x-800",
          "x-1200"
        ]
      },
      {
        "id": "clamayr",
        "label": "ClamAYR",
        "productIds": [
          "clamayr-boondocker-ice-fishing"
        ]
      },
      {
        "id": "apparel",
        "label": "IceArmor Apparel and Boots",
        "productIds": [
          "sub-zero-float-parka",
          "sub-zero-float-bib",
          "vertex-float-parka",
          "vertex-float-bib",
          "womens-sub-zero-float-parka",
          "womens-sub-zero-float-bib",
          "vertex-boot"
        ]
      },
      {
        "id": "rods",
        "label": "Rods and Reels",
        "productIds": [
          "technique-specific-noodle-rods",
          "technique-specific-spring-bobber-rod",
          "technique-specific-dead-meat-rods",
          "technique-specific-rods",
          "technique-specific-predator-rods",
          "sr-ice-750-spinning-reel"
        ]
      },
      {
        "id": "tackle",
        "label": "Tungsten Spoons and Jigs",
        "productIds": [
          "bomb-drop-spoon",
          "dancin-drop",
          "rattlin-drop",
          "diamond-drop",
          "t3-drop",
          "glide-drop"
        ]
      }
    ],
    "transition": {
      "eyebrow": "THE USEFUL DIFFERENCES",
      "heading": "Which setup fits how you fish?",
      "copy": "The best choice depends on how you travel, how much gear you bring and how much space you need. These are the comparisons we walk through at Clam HQ."
    }
  },
  "products": [
    {
      "id": "pack-sled",
      "name": "Pack Sled",
      "brand": "Clam Outdoors",
      "category": "pack-system",
      "scope": "primary_launch",
      "launchPrice": 349.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamPackSled",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/pack-sled.webp",
        "alt": "Pack Sled",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Hauling and seating without a tent. The fold-flat ski platform is the important change for walkers and limited storage space.",
      "indexDetailHref": "#pack-sled",
      "indexDetailLabel": "Details and source",
      "description": "Hauling and seating without a tent. The fold-flat ski platform is the important change for walkers and limited storage space.",
      "specs": [
        "Integrated folding skis",
        "Padded folding seat",
        "Tent-free hauling platform"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/pack-sled",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "pack-trap-1",
      "name": "Pack Trap 1",
      "brand": "Clam Outdoors",
      "category": "pack-system",
      "scope": "primary_launch",
      "launchPrice": 699.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamPackTrap1",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/pack-trap-1.webp",
        "alt": "Pack Trap™ 1",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "My comparison with Kenai comes down to skis versus a tub. Pack Trap is the option I would focus on for hand pulling and compact storage.",
      "indexDetailHref": "#pack-trap-1",
      "indexDetailLabel": "Details and source",
      "description": "My comparison with Kenai comes down to skis versus a tub. Pack Trap is the option I would focus on for hand pulling and compact storage.",
      "specs": [
        "1 angler; 15 sq. ft. fishable area",
        "60 lb.; packs 36 x 38 x 11 in.",
        "60 g/m² insulation; full wind skirt"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/pack-trap-1",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "pack-trap-2",
      "name": "Pack Trap 2",
      "brand": "Clam Outdoors",
      "category": "pack-system",
      "scope": "primary_launch",
      "launchPrice": 799.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamPackTrap2",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/pack-trap-2.webp",
        "alt": "Pack Trap™ 2",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The wider, two-seat Pack Trap keeps the hand-pullable ski platform. It is a different transport choice from a traditional two-person tub shelter.",
      "indexDetailHref": "#pack-trap-2",
      "indexDetailLabel": "Details and source",
      "description": "The wider, two-seat Pack Trap keeps the hand-pullable ski platform. It is a different transport choice from a traditional two-person tub shelter.",
      "specs": [
        "1-2 anglers; two folding seats",
        "72 lb.",
        "Integrated skis and insulated tent"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/pack-trap-2",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "kenai",
      "name": "Kenai",
      "brand": "Clam Outdoors",
      "category": "flip-overs",
      "scope": "primary_launch",
      "launchPrice": 599.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamKenai",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/kenai.webp",
        "alt": "Kenai",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The fixed-pole, flip-and-fish one-person option. Kenai gives you a deeper tub for hauling gear; Pack Trap emphasizes ski-assisted hand pulling and folding storage.",
      "indexDetailHref": "#kenai",
      "indexDetailLabel": "Details and source",
      "description": "The fixed-pole, flip-and-fish one-person option. Kenai gives you a deeper tub for hauling gear; Pack Trap emphasizes ski-assisted hand pulling and folding storage.",
      "specs": [
        "1 angler; 11 sq. ft. fishable area",
        "50 lb.; fixed poles",
        "Sliding cushioned seat"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/kenai",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "nanook",
      "name": "Nanook",
      "brand": "Clam Outdoors",
      "category": "flip-overs",
      "scope": "primary_launch",
      "launchPrice": 899.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamNanook",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/nanook.webp",
        "alt": "Nanook",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The compact traditional two-person choice. The walkthrough shows the revised cushioned rail seats and larger pole system.",
      "indexDetailHref": "#nanook",
      "indexDetailLabel": "Details and source",
      "description": "The compact traditional two-person choice. The walkthrough shows the revised cushioned rail seats and larger pole system.",
      "specs": [
        "2 anglers; 26 sq. ft. fishable area",
        "99 lb.",
        "Upgraded rail seats and 1¼-in. poles"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/nanook",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "yukon",
      "name": "Yukon",
      "brand": "Clam Outdoors",
      "category": "flip-overs",
      "scope": "primary_launch",
      "launchPrice": 999.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamYukon",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/yukon.webp",
        "alt": "Yukon",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Compared with Nanook, the useful upgrade is the deeper gray tub, sloped front and wind skirt. The filmed price step is $100.",
      "indexDetailHref": "#yukon",
      "indexDetailLabel": "Details and source",
      "description": "Compared with Nanook, the useful upgrade is the deeper gray tub, sloped front and wind skirt. The filmed price step is $100.",
      "specs": [
        "2 anglers; 23 sq. ft. fishable area",
        "108 lb.",
        "Co-extruded gray tub and wind skirt"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/yukon",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "denali",
      "name": "Denali",
      "brand": "Clam Outdoors",
      "category": "flip-overs",
      "scope": "primary_launch",
      "launchPrice": 1299.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamDenali",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/denali.webp",
        "alt": "Denali",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Think of this as the roomier two-person option. I show the extra width next to Yukon, and we discuss adding a compatible third seat.",
      "indexDetailHref": "#denali",
      "indexDetailLabel": "Details and source",
      "description": "Think of this as the roomier two-person option. I show the extra width next to Yukon, and we discuss adding a compatible third seat.",
      "specs": [
        "2 anglers; 35 sq. ft. fishable area",
        "130 lb.",
        "Larger gray tub and sloped front"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/denali",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "denali-x4",
      "name": "Denali X4",
      "brand": "Clam Outdoors",
      "category": "flip-overs",
      "scope": "primary_launch",
      "launchPrice": 1999.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamDenaliX4",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/denali-x4.webp",
        "alt": "Denali X4",
        "width": 1080,
        "height": 1080,
        "fit": "contain"
      },
      "indexTakeaway": "A four-seat flip-over with two spaces back to back. Pay attention to machine transport and how the seat assemblies fill the tub when packed.",
      "indexDetailHref": "#denali-x4",
      "indexDetailLabel": "Details and source",
      "description": "A four-seat flip-over with two spaces back to back. Pay attention to machine transport and how the seat assemblies fill the tub when packed.",
      "specs": [
        "4 anglers; 68 sq. ft. fishable area",
        "190 lb.",
        "Back-to-back layout"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/denali-x4",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "x-400",
      "name": "X-400 Hub Shelter",
      "brand": "Clam Outdoors",
      "category": "hubs",
      "scope": "primary_launch",
      "launchPrice": 549.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamX-400",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/x-400.webp",
        "alt": "X-400 Hub Shelter",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The four X-Series sizes share the revised skirting anchors, gray interior and reinforced pole-pocket design. Choose the space for your group and gear.",
      "indexDetailHref": "#x-400",
      "indexDetailLabel": "Details and source",
      "description": "The four X-Series sizes share the revised skirting anchors, gray interior and reinforced pole-pocket design. Choose the space for your group and gear.",
      "specs": [
        "Updated exterior anchoring",
        "Reinforced PVC pole pockets",
        "Thermal hub shelter"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/x-400",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "x-600",
      "name": "X-600 Hub Shelter",
      "brand": "Clam Outdoors",
      "category": "hubs",
      "scope": "primary_launch",
      "launchPrice": 749.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamX-600",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/x-600.webp",
        "alt": "X-600 Hub Shelter",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The four X-Series sizes share the revised skirting anchors, gray interior and reinforced pole-pocket design. Choose the space for your group and gear.",
      "indexDetailHref": "#x-600",
      "indexDetailLabel": "Details and source",
      "description": "The four X-Series sizes share the revised skirting anchors, gray interior and reinforced pole-pocket design. Choose the space for your group and gear.",
      "specs": [
        "Updated exterior anchoring",
        "Reinforced PVC pole pockets",
        "Thermal hub shelter"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/x-600",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "x-800",
      "name": "X-800 Hub Shelter",
      "brand": "Clam Outdoors",
      "category": "hubs",
      "scope": "primary_launch",
      "launchPrice": 949.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamX-800",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/x-800.webp",
        "alt": "X-800 Hub Shelter",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The four X-Series sizes share the revised skirting anchors, gray interior and reinforced pole-pocket design. Choose the space for your group and gear.",
      "indexDetailHref": "#x-800",
      "indexDetailLabel": "Details and source",
      "description": "The four X-Series sizes share the revised skirting anchors, gray interior and reinforced pole-pocket design. Choose the space for your group and gear.",
      "specs": [
        "Updated exterior anchoring",
        "Reinforced PVC pole pockets",
        "Thermal hub shelter"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/x-800",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "x-1200",
      "name": "X-1200 Hub Shelter",
      "brand": "Clam Outdoors",
      "category": "hubs",
      "scope": "primary_launch",
      "launchPrice": 1349.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamX-1200",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/x-1200.webp",
        "alt": "X-1200 Hub Shelter",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The four X-Series sizes share the revised skirting anchors, gray interior and reinforced pole-pocket design. Choose the space for your group and gear.",
      "indexDetailHref": "#x-1200",
      "indexDetailLabel": "Details and source",
      "description": "The four X-Series sizes share the revised skirting anchors, gray interior and reinforced pole-pocket design. Choose the space for your group and gear.",
      "specs": [
        "Updated exterior anchoring",
        "Reinforced PVC pole pockets",
        "Thermal hub shelter"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/x-1200",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "clamayr-boondocker-ice-fishing",
      "name": "ClamAYR Boondocker Inflatable Shelter - Ice Fishing",
      "brand": "Clam Outdoors",
      "category": "clamayr",
      "scope": "primary_launch",
      "launchPrice": 2499.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamAYRIce",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/clamayr-boondocker-ice-fishing.webp",
        "alt": "ClamAYR Boondocker Inflatable Shelter - Ice Fishing",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Ice-specific wall panels and no included floor give access to the ice. Choose a suitable pump separately; compare the actual package rather than the old launch price alone.",
      "indexDetailHref": "#clamayr-boondocker-ice-fishing",
      "indexDetailLabel": "Details and source",
      "description": "Ice-specific wall panels and no included floor give access to the ice. Choose a suitable pump separately; compare the actual package rather than the old launch price alone.",
      "specs": [
        "Ice-specific inflatable shelter",
        "No floor or pump included in the base package",
        "Clam recommends 10 PSI"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/clamayr-boondocker-ice-fishing",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "sub-zero-float-parka",
      "name": "Sub-Zero Float Parka",
      "brand": "Clam Outdoors",
      "category": "apparel",
      "scope": "primary_launch",
      "launchPrice": 229.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamSubZeroFloatParka",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/sub-zero-float-parka.webp",
        "alt": "Sub-Zero Float Parka",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Clam presents Sub-Zero as the cold-weather option for less-active fishing and machine travel. Pair the parka and bib for the full suit.",
      "indexDetailHref": "#sub-zero-float-parka",
      "indexDetailLabel": "Details and source",
      "description": "Clam presents Sub-Zero as the cold-weather option for less-active fishing and machine travel. Pair the parka and bib for the full suit.",
      "specs": [
        "IceArmor MotionFloat flotation assistance",
        "Select garment size and color separately"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/sub-zero-float-parka",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "sub-zero-float-bib",
      "name": "Sub-Zero Float Bib",
      "brand": "Clam Outdoors",
      "category": "apparel",
      "scope": "primary_launch",
      "launchPrice": 229.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamSubZeroFloatBibs",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/sub-zero-float-bib.webp",
        "alt": "Sub-Zero Float Bib",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Clam presents Sub-Zero as the cold-weather option for less-active fishing and machine travel. Pair the parka and bib for the full suit.",
      "indexDetailHref": "#sub-zero-float-bib",
      "indexDetailLabel": "Details and source",
      "description": "Clam presents Sub-Zero as the cold-weather option for less-active fishing and machine travel. Pair the parka and bib for the full suit.",
      "specs": [
        "IceArmor MotionFloat flotation assistance",
        "Select garment size and color separately"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/sub-zero-float-bib",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "vertex-float-parka",
      "name": "Vertex Float Parka",
      "brand": "Clam Outdoors",
      "category": "apparel",
      "scope": "primary_launch",
      "launchPrice": 329.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamVertexFloatParka",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/vertex-float-parka.webp",
        "alt": "Vertex Float Parka",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Clam’s lighter, more mobile suit option in the employee walkthrough. It is aimed at the angler who is moving, drilling and chasing fish.",
      "indexDetailHref": "#vertex-float-parka",
      "indexDetailLabel": "Details and source",
      "description": "Clam’s lighter, more mobile suit option in the employee walkthrough. It is aimed at the angler who is moving, drilling and chasing fish.",
      "specs": [
        "IceArmor MotionFloat flotation assistance",
        "PrimaLoft insulation",
        "Matching parka and bib sold separately"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/vertex-float-parka",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "vertex-float-bib",
      "name": "Vertex Float Bib",
      "brand": "Clam Outdoors",
      "category": "apparel",
      "scope": "primary_launch",
      "launchPrice": 329.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamVertexFloatBib",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/vertex-float-bib.webp",
        "alt": "Vertex Float Bib",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Clam’s lighter, more mobile suit option in the employee walkthrough. It is aimed at the angler who is moving, drilling and chasing fish.",
      "indexDetailHref": "#vertex-float-bib",
      "indexDetailLabel": "Details and source",
      "description": "Clam’s lighter, more mobile suit option in the employee walkthrough. It is aimed at the angler who is moving, drilling and chasing fish.",
      "specs": [
        "IceArmor MotionFloat flotation assistance",
        "PrimaLoft insulation",
        "Matching parka and bib sold separately"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/vertex-float-bib",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "womens-sub-zero-float-parka",
      "name": "Women's Sub-Zero Float Parka",
      "brand": "Clam Outdoors",
      "category": "apparel",
      "scope": "primary_launch",
      "launchPrice": 249.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamSubZeroFloatParkaW",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/womens-sub-zero-float-parka.webp",
        "alt": "Women's Sub-Zero Float Parka",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Clam presents Sub-Zero as its warmer cold-weather option. The women’s parka and bib are separate garments with their own fit and pricing.",
      "indexDetailHref": "#womens-sub-zero-float-parka",
      "indexDetailLabel": "Details and source",
      "description": "Clam presents Sub-Zero as its warmer cold-weather option. The women’s parka and bib are separate garments with their own fit and pricing.",
      "specs": [
        "IceArmor MotionFloat flotation assistance",
        "Select garment size and color separately"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/womens-sub-zero-float-parka",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "womens-sub-zero-float-bib",
      "name": "Women's Sub-Zero Float Bib",
      "brand": "Clam Outdoors",
      "category": "apparel",
      "scope": "primary_launch",
      "launchPrice": 249.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamSubZeroFloatBibW",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/womens-sub-zero-float-bib.webp",
        "alt": "Women's Sub-Zero Float Bib",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Clam presents Sub-Zero as its warmer cold-weather option. The women’s parka and bib are separate garments with their own fit and pricing.",
      "indexDetailHref": "#womens-sub-zero-float-bib",
      "indexDetailLabel": "Details and source",
      "description": "Clam presents Sub-Zero as its warmer cold-weather option. The women’s parka and bib are separate garments with their own fit and pricing.",
      "specs": [
        "IceArmor MotionFloat flotation assistance",
        "Select garment size and color separately"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/womens-sub-zero-float-bib",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "vertex-boot",
      "name": "Vertex Boots",
      "brand": "Clam Outdoors",
      "category": "apparel",
      "scope": "primary_launch",
      "launchPrice": 299.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamVertexBoots",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/vertex-boot.webp",
        "alt": "Vertex Boots",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The removable liner is a useful part of the demonstration: take it out to dry separately. Clam positions Vertex as the lighter, more mobile boot.",
      "indexDetailHref": "#vertex-boot",
      "indexDetailLabel": "Details and source",
      "description": "The removable liner is a useful part of the demonstration: take it out to dry separately. Clam positions Vertex as the lighter, more mobile boot.",
      "specs": [
        "Removable aerogel-infused liner",
        "Waterproof lower construction",
        "Clam temperature ratings are manufacturer claims"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/vertex-boot",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "technique-specific-noodle-rods",
      "name": "TS Series Noodle Rods",
      "brand": "Clam Outdoors",
      "category": "rods",
      "scope": "primary_launch",
      "launchPrice": 59.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamTSIceRods",
      "ctaLabel": "Shop TS rod lineup",
      "image": {
        "src": "/images/launches/clam-2026-27/technique-specific-noodle-rods.webp",
        "alt": "TS Series Noodle Rods",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "A high-visibility noodle tip for watching light panfish and perch bites. Pick the length that fits your fishing position.",
      "indexDetailHref": "#technique-specific-noodle-rods",
      "indexDetailLabel": "Details and source",
      "description": "A high-visibility noodle tip for watching light panfish and perch bites. Pick the length that fits your fishing position.",
      "specs": [
        "24, 28 and 34 in. Noodle models",
        "High-visibility tip",
        "Titanium recoil stripper guide"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/technique-specific-noodle-rods",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "technique-specific-spring-bobber-rod",
      "name": "TS Series Spring Bobber Rod",
      "brand": "Clam Outdoors",
      "category": "rods",
      "scope": "primary_launch",
      "launchPrice": 59.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamTSIceRods",
      "ctaLabel": "Shop TS rod lineup",
      "image": {
        "src": "/images/launches/clam-2026-27/technique-specific-spring-bobber-rod.webp",
        "alt": "TS Series Spring Bobber Rod",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The visual-bite option with a nitinol spring bobber for subtle up-bites and slack-line strikes.",
      "indexDetailHref": "#technique-specific-spring-bobber-rod",
      "indexDetailLabel": "Details and source",
      "description": "The visual-bite option with a nitinol spring bobber for subtle up-bites and slack-line strikes.",
      "specs": [
        "27 in. Ultra-Light",
        "Nitinol spring bobber",
        "Titanium recoil stripper guide"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/technique-specific-spring-bobber-rod",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "technique-specific-dead-meat-rods",
      "name": "TS Series Dead Meat Rods",
      "brand": "Clam Outdoors",
      "category": "rods",
      "scope": "primary_launch",
      "launchPrice": 59.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamTSIceRods",
      "ctaLabel": "Shop TS rod lineup",
      "image": {
        "src": "/images/launches/clam-2026-27/technique-specific-dead-meat-rods.webp",
        "alt": "TS Series Dead Meat Rods",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The familiar Dead Meat fiberglass action, brought into the consolidated TS lineup with the updated handle and guides.",
      "indexDetailHref": "#technique-specific-dead-meat-rods",
      "indexDetailLabel": "Details and source",
      "description": "The familiar Dead Meat fiberglass action, brought into the consolidated TS lineup with the updated handle and guides.",
      "specs": [
        "28, 32 and 36 in. Medium models",
        "Fiberglass blank",
        "Titanium recoil stripper guide"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/technique-specific-dead-meat-rods",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "technique-specific-rods",
      "name": "TS Series Rods",
      "brand": "Clam Outdoors",
      "category": "rods",
      "scope": "primary_launch",
      "launchPrice": 59.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamTSIceRods",
      "ctaLabel": "Shop TS rod lineup",
      "image": {
        "src": "/images/launches/clam-2026-27/technique-specific-rods.webp",
        "alt": "TS Series Rods",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The graphite range runs from panfish and walleye presentations to three larger big-fish rods. Match the length and action to the lure and target fish.",
      "indexDetailHref": "#technique-specific-rods",
      "indexDetailLabel": "Details and source",
      "description": "The graphite range runs from panfish and walleye presentations to three larger big-fish rods. Match the length and action to the lure and target fish.",
      "specs": [
        "26-34 in. Ultra-Light through Medium",
        "41 in. Medium-Heavy; 43 and 48 in. Heavy",
        "Graphite blanks"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/technique-specific-rods",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "technique-specific-predator-rods",
      "name": "TS Series Predator Rods",
      "brand": "Clam Outdoors",
      "category": "rods",
      "scope": "primary_launch",
      "launchPrice": 59.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamTSIceRods",
      "ctaLabel": "Shop TS rod lineup",
      "image": {
        "src": "/images/launches/clam-2026-27/technique-specific-predator-rods.webp",
        "alt": "TS Series Predator Rods",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The fiberglass set-line and Predator Tip-Up pairing. The forgiving blank is intended for larger fish and compatible automatic hook-setting setups.",
      "indexDetailHref": "#technique-specific-predator-rods",
      "indexDetailLabel": "Details and source",
      "description": "The fiberglass set-line and Predator Tip-Up pairing. The forgiving blank is intended for larger fish and compatible automatic hook-setting setups.",
      "specs": [
        "36 in. Medium; 42 in. Medium-Heavy; 48 in. Heavy",
        "Fiberglass blanks",
        "Titanium recoil stripper guide"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/technique-specific-predator-rods",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "sr-ice-750-spinning-reel",
      "name": "SR-ICE Spinning Reel",
      "brand": "Clam Outdoors",
      "category": "rods",
      "scope": "primary_launch",
      "launchPrice": 59.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamSRIceSpinningReel",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/sr-ice-750-spinning-reel.webp",
        "alt": "SR-ICE Spinning Reel",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Choose 750 for smaller presentations or 2000 for Predator and big-fish rods. The walkthrough highlights low-temperature grease and a folding handle for ice-fishing storage.",
      "indexDetailHref": "#sr-ice-750-spinning-reel",
      "indexDetailLabel": "Details and source",
      "description": "Choose 750 for smaller presentations or 2000 for Predator and big-fish rods. The walkthrough highlights low-temperature grease and a folding handle for ice-fishing storage.",
      "specs": [
        "750 and 2000 sizes",
        "6.2:1 gear ratio; 5+1 bearings",
        "One-touch folding handle"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/sr-ice-750-spinning-reel",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "bomb-drop-spoon",
      "name": "Bomb Drop Spoon",
      "brand": "Clam Outdoors",
      "category": "tackle",
      "scope": "primary_launch",
      "launchPrice": 7.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamBombDropSpoon",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/bomb-drop-spoon.webp",
        "alt": "Bomb Drop Spoon",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "Clam describes the slender tungsten profile as the fast-dropping option for getting back to deeper fish.",
      "indexDetailHref": "#bomb-drop-spoon",
      "indexDetailLabel": "Details and source",
      "description": "Clam describes the slender tungsten profile as the fast-dropping option for getting back to deeper fish.",
      "specs": [
        "Tungsten spoon",
        "Slim minnow profile"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/bomb-drop-spoon",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "dancin-drop",
      "name": "Dancin' Drop Spoon",
      "brand": "Clam Outdoors",
      "category": "tackle",
      "scope": "primary_launch",
      "launchPrice": 7.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamDancinDropSpoon",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/dancin-drop.webp",
        "alt": "Dancin' Drop Spoon",
        "width": 1200,
        "height": 1200,
        "fit": "contain"
      },
      "indexTakeaway": "The fluttering option in the new tungsten spoon lineup, compared with Bomb Drop’s straighter fast-drop emphasis.",
      "indexDetailHref": "#dancin-drop",
      "indexDetailLabel": "Details and source",
      "description": "The fluttering option in the new tungsten spoon lineup, compared with Bomb Drop’s straighter fast-drop emphasis.",
      "specs": [
        "Tungsten spoon",
        "Fluttering action"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/dancin-drop",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "rattlin-drop",
      "name": "Rattlin' Drop Spoon",
      "brand": "Clam Outdoors",
      "category": "tackle",
      "scope": "primary_launch",
      "launchPrice": 7.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamnRattlinDropSpoon",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/rattlin-drop.webp",
        "alt": "Rattlin' Drop Spoon",
        "width": 1080,
        "height": 1080,
        "fit": "contain"
      },
      "indexTakeaway": "The tungsten spoon with an audible rattle. Choose the size and pack configuration at the retailer.",
      "indexDetailHref": "#rattlin-drop",
      "indexDetailLabel": "Details and source",
      "description": "The tungsten spoon with an audible rattle. Choose the size and pack configuration at the retailer.",
      "specs": [
        "Tungsten spoon",
        "Internal rattle"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/rattlin-drop",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "diamond-drop",
      "name": "Diamond Drop Spoon",
      "brand": "Clam Outdoors",
      "category": "tackle",
      "scope": "primary_launch",
      "launchPrice": 7.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamDiamondDropSpoon",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/diamond-drop.webp",
        "alt": "Diamond Drop Spoon",
        "width": 1080,
        "height": 1080,
        "fit": "contain"
      },
      "indexTakeaway": "A broader spoon profile and added blade give this tungsten option a different flash and action.",
      "indexDetailHref": "#diamond-drop",
      "indexDetailLabel": "Details and source",
      "description": "A broader spoon profile and added blade give this tungsten option a different flash and action.",
      "specs": [
        "Tungsten spoon",
        "Added flash blade"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/diamond-drop",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "t3-drop",
      "name": "T3 Drop",
      "brand": "Clam Outdoors",
      "category": "tackle",
      "scope": "primary_launch",
      "launchPrice": 6.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamT3DropJig",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/t3-drop.webp",
        "alt": "T3 Drop",
        "width": 1080,
        "height": 1080,
        "fit": "contain"
      },
      "indexTakeaway": "The smaller live-bait and small-plastic jig in the walkthrough, with eyes on three sides.",
      "indexDetailHref": "#t3-drop",
      "indexDetailLabel": "Details and source",
      "description": "The smaller live-bait and small-plastic jig in the walkthrough, with eyes on three sides.",
      "specs": [
        "Tungsten jig",
        "Three-sided eye placement"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/t3-drop",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    },
    {
      "id": "glide-drop",
      "name": "Glide Drop",
      "brand": "Clam Outdoors",
      "category": "tackle",
      "scope": "primary_launch",
      "launchPrice": 6.99,
      "priceLabel": "Clam listed price",
      "affiliateUrl": "https://at.fish/ClamGlideDropJig",
      "ctaLabel": "Check current price",
      "image": {
        "src": "/images/launches/clam-2026-27/glide-drop.webp",
        "alt": "Glide Drop",
        "width": 1080,
        "height": 1080,
        "fit": "contain"
      },
      "indexTakeaway": "The larger-plastic pairing in the walkthrough. Clam discusses using it with baits such as Flutter Fry and Soldier Fly.",
      "indexDetailHref": "#glide-drop",
      "indexDetailLabel": "Details and source",
      "description": "The larger-plastic pairing in the walkthrough. Clam discusses using it with baits such as Flutter Fry and Soldier Fly.",
      "specs": [
        "Tungsten jig",
        "Larger-plastic presentations"
      ],
      "sourceUrl": "https://clamoutdoors.com/products/glide-drop",
      "sourceLabel": "Official Clam specifications",
      "defaultPlacement": "product_detail"
    }
  ],
  "guideSections": [
    {
      "id": "pack-system",
      "heading": "Pack System",
      "paragraphs": [
        "The same ski-platform idea runs through the open Pack Sled and the one- and two-person Pack Traps. The open sled is for hauling and seating; the Pack Traps add insulated shelter.",
        "In the filmed discussion, Pack Trap’s thermal construction is 210D interior fabric, 60 g/m² insulation and 210D exterior fabric. The full skirt is another important part of keeping wind out."
      ],
      "productIds": [
        "pack-sled",
        "pack-trap-1",
        "pack-trap-2"
      ]
    },
    {
      "id": "flip-overs",
      "heading": "Flip-over Shelters",
      "paragraphs": [
        "Start with the lineup: Kenai is the fixed-pole one-person shelter, Nanook is the compact two-person tub model, Yukon adds the deeper gray tub and wind skirt, Denali adds room, and Denali X4 is the four-seat option.",
        "My practical comparison is the space you can use and the tub you have to move. Inspect packed dimensions, machine transport and loading weight alongside fishable floor space. A compatible extra seat can expand Denali’s seating; check fit before buying."
      ],
      "productIds": [
        "kenai",
        "nanook",
        "yukon",
        "denali",
        "denali-x4"
      ]
    },
    {
      "id": "hubs",
      "heading": "X-Series Hubs",
      "paragraphs": [
        "All four X-Series sizes share the revised skirting anchors and reinforced PVC pole pockets discussed in the walkthrough. The decision is size and layout for the people and gear you actually bring."
      ],
      "productIds": [
        "x-400",
        "x-600",
        "x-800",
        "x-1200"
      ]
    },
    {
      "id": "clamayr",
      "heading": "ClamAYR",
      "paragraphs": [
        "The ice model removes the included floor and uses ice-specific wall panels. The all-year Boondocker has a different camping-oriented package; compare what is included. Both are repairable systems with replaceable panels discussed in the video.",
        "The filmed $1,500 price comparison uses the original $3,999.99 all-year announcement. As checked October 23, the all-year listing is $2,999.99 and the ice-specific shelter is $2,499.99. Current difference: $500 before accessories.",
        "Clam recommends 10 PSI. The separately available standard AYR Force pump and Deluxe pump have different inflation speeds. The Link Panel connects shelters; the Climate Port Panel provides utility/heating ports. Confirm the exact package, accessories and operating instructions."
      ],
      "productIds": [
        "clamayr-boondocker-ice-fishing"
      ]
    },
    {
      "id": "apparel",
      "heading": "IceArmor Apparel and Boots",
      "paragraphs": [
        "Sub-Zero is the warmer cold-weather suit in Clam’s presentation; Vertex is the lighter option for moving, drilling and chasing fish. Compare the weight and insulation of the exact garment rather than the name alone.",
        "The women’s Sub-Zero parka and bib have their own sizing and price. Vertex boots use a removable liner that can dry separately, a useful feature shown in the walkthrough."
      ],
      "productIds": [
        "sub-zero-float-parka",
        "sub-zero-float-bib",
        "vertex-float-parka",
        "vertex-float-bib",
        "womens-sub-zero-float-parka",
        "womens-sub-zero-float-bib",
        "vertex-boot"
      ]
    },
    {
      "id": "rods",
      "heading": "Rods and Reels",
      "paragraphs": [
        "Choose the technique before the length and action: Noodle and Spring Bobber for visual bite detection, Dead Meat for the familiar fiberglass action, graphite for active presentations and larger fish, and Predator for set-line or compatible tip-up use.",
        "The shared buying link opens the TS lineup, rather than a preselected exact rod. Choose the correct family and variant there. The SR-ICE reels discussed in the video come in 750 and 2000 sizes."
      ],
      "productIds": [
        "technique-specific-noodle-rods",
        "technique-specific-spring-bobber-rod",
        "technique-specific-dead-meat-rods",
        "technique-specific-rods",
        "technique-specific-predator-rods",
        "sr-ice-750-spinning-reel"
      ]
    },
    {
      "id": "tackle",
      "heading": "Tungsten Spoons and Jigs",
      "paragraphs": [
        "The four tungsten spoons offer distinct profiles: Bomb Drop for fast drops, Dancin’ Drop for flutter, Rattlin’ Drop for sound and Diamond Drop for added flash. Those are the manufacturer’s presentation descriptions from the first look.",
        "T3 is the smaller live-bait/small-plastic jig; Glide Drop is discussed with larger plastics. Select the size, color and pack configuration at the retailer."
      ],
      "productIds": [
        "bomb-drop-spoon",
        "dancin-drop",
        "rattlin-drop",
        "diamond-drop",
        "t3-drop",
        "glide-drop"
      ]
    }
  ],
  "faqs": [
    {
      "question": "Is this a sponsored review or a season-long field test?",
      "answer": "No. I buy my own fishing gear and receive no free products, paid reviews or money from fishing brands. This is a behind-the-scenes hands-on first look; manufacturer performance claims are identified as such."
    },
    {
      "question": "Pack Trap skis or a traditional FishTrap tub?",
      "answer": "Pack Trap emphasizes hand pulling, folding skis and compact storage. Kenai is the fixed-pole flip-and-fish one-person option with a deeper storage tub. Choose around your transport and packing needs rather than weight alone."
    },
    {
      "question": "Does the ice-specific ClamAYR include a pump?",
      "answer": "The current base ice-shelter package does not include a pump or floor. Clam recommends inflating to 10 PSI. Its standard AYR Force and faster Deluxe are separate choices; check the pump and package before buying."
    },
    {
      "question": "What does the $1,500 ClamAYR comparison in the video mean?",
      "answer": "It compares the $2,499.99 ice-specific model with the original $3,999.99 all-year launch announcement. The current manufacturer all-year listing is $2,999.99, so today’s base-price difference is $500 before accessories. It is not an evergreen $1,500 discount."
    },
    {
      "question": "How should I pair the new rods and reels?",
      "answer": "Choose the TS rod family, length and action for the technique first. In the walkthrough, Clam pairs the SR-ICE 750 with smaller presentations and the 2000 with Predator, big-fish or heavier walleye setups. Confirm the exact model and size before buying."
    }
  ],
  "snapshot": {
    "heading": "Sources and price context",
    "copy": "Manufacturer listed prices checked October 23, 2026. Retail prices, availability and package contents can change. Use the buying links beside each product to check current options.",
    "checkedOn": "2026-10-23"
  },
  "shareAsset": {
    "enabled": true,
    "shortUrl": "https://at.fish/Clam26",
    "displayUrl": "at.fish/Clam26",
    "headline": "ALL THE NEW CLAM GEAR",
    "supportingText": "Specs, comparisons & current buying links",
    "filename": "angler-built-clam-2026-27-qr.png",
    "barColor": "#0F50F2",
    "bottomBarColor": "#000000"
  },
  "sources": [
    {
      "label": "Original ClamAYR all-year launch announcement",
      "url": "https://clamoutdoors.com/blogs/blog/clamayr%E2%84%A2-redefining-outdoor-adventure-year-round%E2%84%A2"
    },
    {
      "label": "Current all-year Boondocker package and price",
      "url": "https://clamoutdoors.com/products/clamayr-boondocker-all-year-round"
    }
  ],
  "heroCta": {
    "href": "#whats-new",
    "label": "See the gear and buying links"
  }
};
